import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/ui/Modal/Modal";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import { CloseIcon } from "@/assets/icons";
import { useTariffLayer } from "@/store/mode";
import { useKuperModalStore } from "@/store/useKuperModalStore";
import cls from "./styles.module.scss";

export const PromoKuperModal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const serviceLayer = useTariffLayer((s) => s.serviceLayer);
  const wasKuperModalShown = useKuperModalStore((s) => s.wasKuperModalShown);
  const disableKuperModal = useKuperModalStore((s) => s.disableKuperModal);

  const onClose = () => {
    setIsOpen(false);
    disableKuperModal();
  };

  useEffect(() => {
    if (serviceLayer === "kuper" || wasKuperModalShown) return;

    setIsOpen(true);
  }, []);

  useEffect(() => {
    if (serviceLayer === "kuper") onClose();
  }, [serviceLayer]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseBtn
      overlayCls={cls.overlay}
      wrapperCls={cls.wrapper}
      contentCls={cls.content}
      usePortal={false}
    >
      <div className={cls.imgBlock}>
        <img src="/assets/kuper_modal.png" alt="Купер уже здесь" />

        <button type="button" onClick={onClose} className={cls.closeBtn}>
          <CloseIcon />
        </button>
      </div>

      <FlexColumn gap={12} className={cls.info}>
        <h2 className={cls.title}>{t("promoKuperModal.kuperHere")}</h2>
        <p className={cls.desc}>{t("promoKuperModal.pressSwitch")}</p>
      </FlexColumn>
    </Modal>
  );
};
